module.exports = __webpack_public_path__ + "img/stonehatchet.71dfd7de.png";